import React, {ReactNode} from 'react';
import {Card, Row, Col, Badge} from '@goproblems/ui';
import {Problem, FavoritedProblem, CreatedProblem, ProblemEntry} from '@types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faCheckCircle,
    faClock,
    faUser,
} from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

function contextDataToUrlParams(contextData: Record<string, string | number>) {
    return Object.keys(contextData).length > 0
        ? '?' +
              Object.entries(contextData)
                  .map(
                      ([key, value]) =>
                          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
                  )
                  .join('&')
        : '';
}

export const ProblemsRow = ({
    problems = [],
    onProblemClick,
    problemBody,
    contextData = {},
}: {
    problems?:
        | Problem[]
        | CreatedProblem[]
        | FavoritedProblem[]
        | ProblemEntry[];
    onProblemClick?: (problem: ProblemEntry | Problem) => void;
    problemBody?: (
        problem: Problem | CreatedProblem | FavoritedProblem | ProblemEntry
    ) => ReactNode;
    contextData?: Record<string, string | number>;
}) => (
    <Row>
        {problems.map(problem => (
            <Col
                key={problem.id}
                xs={6}
                sm={6}
                md={2}
                lg={2}
                style={{cursor: 'pointer'}}
                onClick={() => {
                    if (onProblemClick) {
                        onProblemClick(problem);
                    } else {
                        window.location.href = `/problems/${problem.id}${contextDataToUrlParams(contextData)}`;
                    }
                }}>
                <Card className="relative h-full">
                    <span className="absolute inset-x-0 top-0 z-10">
                        <Badge className="mt-1 ms-1" bg="light">
                            {problem.difficulty}
                        </Badge>
                        {problem.solves + problem.fails > 0 && (
                            <Badge className="bg-light mt-1 me-1 float-end lh-1">
                                <FontAwesomeIcon
                                    icon={faCheckCircle}
                                    className={
                                        problem.solves > 0
                                            ? 'text-success'
                                            : 'text-danger'
                                    }
                                />
                            </Badge>
                        )}
                        <span className="badge bg-light  mt-1 ms-1"></span>
                    </span>
                    <Card.Img variant="top" src={problem.imageUrl} />
                    <Card.Body className="p-2">
                        {problemBody ? (
                            problemBody(problem)
                        ) : (
                            <span className="text-muted d-inline-block text-truncate max-width-140">
                                <small>
                                    <FontAwesomeIcon icon={faClock} />
                                    <span className="ml-1">
                                        {dayjs(problem.createdAt).fromNow()}
                                    </span>
                                </small>
                                <br />
                                <small>
                                    <FontAwesomeIcon icon={faUser} />
                                    <span className="ml-1">
                                        {problem.author.name}
                                    </span>
                                </small>
                            </span>
                        )}
                    </Card.Body>
                </Card>
            </Col>
        ))}
    </Row>
);
